export enum MapControlName {
    METEO = 'meteoState',
    AIR_QUALITY = 'airQuality'
}
